export enum EnumUserRoles {
	NORMAL_USER = 'NORMAL_USER',
	PUBLISHER = 'PUBLISHER',
	MODERATOR = 'MODERATOR',
	JOB_PUBLISHER = 'JOB_PUBLISHER',
	COMPANY_MANAGER = 'COMPANY_MANAGER',
	COMPANY_ADMIN = 'COMPANY_ADMIN',
}
